import { useTabPanel } from '@react-aria/tabs';
import React, { useRef } from 'react';

// styles
import styles from './sliding-tabs.module.scss';

export function TabPanel({ state, ...props }) {
  const ref = useRef<HTMLDivElement>(null);
  const { tabPanelProps } = useTabPanel(props, state, ref);

  const [id, setID] = React.useState<string>('');
  const [ariaLabelledby, setAriaLabelledby] = React.useState<string>('');

  React.useEffect(() => {
    if (!tabPanelProps?.id) return;
    setID(tabPanelProps.id);
  }, []);

  React.useEffect(() => {
    if (!tabPanelProps['aria-labelledby']) return;
    setAriaLabelledby(tabPanelProps['aria-labelledby']);
  }, []);

  return (
    <div
      {...tabPanelProps}
      id={id}
      aria-labelledby={ariaLabelledby}
      className={styles.tabPanel}
      ref={ref}
    >
      {state.selectedItem?.props.children}
    </div>
  );
}
